// extracted by mini-css-extract-plugin
export default {"container":"adminStatistika_container__sfnMi","top":"adminStatistika_top__dG9RP","btn":"adminStatistika_btn__qGhWF","postContainer":"adminStatistika_postContainer__6HQI4"};